import * as React from "react";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTheme, useMediaQuery } from "@mui/material";

export default function ExtendedCompanyInfo({ data }) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const [open, setOpen] = React.useState(false);

	const handleTooltipClose = () => {
		setOpen(false);
	};

	const handleTooltipOpen = () => {
		setOpen(!open);
	};

	const title = (
		<>
			<div>Full name: {data.companyName}</div>
			<br />
			<div>Exchange: {data.exchange}</div>
			<br />
			<div>Industry: {data.industry}</div>
			<br />
			<div>Sector: {data.sector}</div>
			<br />
			<div>
				Website: {data.website}
				{/* Website: <a href={`${data.website}`}>{data.website}</a> */}
			</div>
			<br />
			<div>Description: {data.description}</div>
			<br />
			<div>CEO: {data.ceo}</div>
			<br />
			<div>Country: {data.country}</div>
			<br />
			<div>Employees: {data.fullTimeEmployees}</div>
			<br />
			<div>IPO date: {data.ipoDate}</div>
		</>
	);

	return (
		<ClickAwayListener onClickAway={handleTooltipClose}>
			<Tooltip
				arrow
				onClose={handleTooltipClose}
				open={open}
				disableFocusListener
				disableHoverListener
				disableTouchListener
				title={title}
				slotProps={{
					popper: {
						disablePortal: true,
					},
					arrow: {
						style: {
							color: "rgba(50, 50, 50, 0.97)", // Less transparent black background
						},
					},
					tooltip: {
						style: {
							maxWidth: isMobile ? "88vw" : "550px", // Increased width
							fontSize: "15px", // Larger font size
							borderRadius: 12, // Optional styling
							padding: ".75rem", // Adjust padding for spacing
							lineHeight: "1.2", // Better line spacing
							// bgcolor: "black",
							backgroundColor: "rgba(50, 50, 50, 0.97)", // Less transparent black background
						},
					},
				}}
			>
				<IconButton
					aria-label="extended company information"
					onClick={handleTooltipOpen}
					sx={{
						margin: "auto",
						mt: 1.2,
						display: "flex",
						p: 0,
					}}
				>
					<InfoOutlinedIcon />
				</IconButton>
			</Tooltip>
		</ClickAwayListener>
	);
}
